module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-PennyMac-Pet.3031f327.gif";